import React from 'react'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import styles from '../../../../containers/Forms/Forms.css'
import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTypography-body1': {
      color: '#6B7897',
      fontSize: 13,
      fontWeight: 'bold',
    },
    '& .Mui-checked': {
      color: '#2D9F86',
    },
  },
  radio: {
    colorPrimary: {
      '&$checked': {
        color: '#2D9F86',
      },
    },
    checked: {},
  },
}))


const RadioButton = props => {
  const {
    input,
    name,
    label,
    getLabel,
    required,
    options,
  } = props

  const classes = useStyles()
  const inputComponent = typeof getLabel === 'function'
    ? getLabel()
    : <span className={styles.label}>{label}</span>

  const [ val, setVal ] = React.useState('')

  const handleChange = event => {
    setVal(event.target.value)
  }
  return (
    <FormControl component="fieldset">
      {required &&
        <span className={styles.required} />
      }
      {inputComponent}
      <RadioGroup {...input} aria-label={input.name} row name={input.name} value={val} onChange={handleChange}>
        {options.map(item =>
          <h3>
            <FormControlLabel {...input} name={item.id} className={classes.root} value={item.id} control={<Radio />} label={item.name} />
          </h3>)}
      </RadioGroup>
    </FormControl>
  )
}

export default RadioButton



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/RadioButton/RadioButton.jsx